import React from "react";
import styles from "./ChatShimmer.module.css";
import chatstyles from "../../../../style/components/chat/ChatView.module.css";

const ChatShimmer = () => {
  return (
    <div className={chatstyles.ChatViewMaincontentChatview}>
      <div className={chatstyles.ChatViewMaincontentChatviewsb}>
        {[...Array(5)].map((_, index) => {
          const isReceived = index % 2 === 0;
          return (
            <div key={index} className={styles.ShimmerMessageContainer}>
              <div
                className={
                  isReceived ? styles.ShimmerReceived : styles.ShimmerSent
                }
              >
                {isReceived && <div className={styles.ShimmerAvatar} />}

                <div className={styles.ShimmerContent}>
                  <div
                    className={`${styles.ShimmerHeader} ${
                      isReceived ? styles.AlignLeft : styles.AlignRight
                    }`}
                  >
                    <div className={styles.ShimmerName} />
                    <div className={styles.ShimmerTimestamp} />
                  </div>
                  <div className={styles.ShimmerBubble} />
                </div>

                {!isReceived && <div className={styles.ShimmerAvatar} />}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ChatShimmer;
